(function(){
  var el = document.getElementById('cp-data'); if (!el) return;
  var d; try { d = JSON.parse(el.textContent); } catch (e) { return; }
  var start = Date.parse(d.start), end = Date.parse(d.end), now = Date.now();
  var live = (!start || now >= start) && (!end || now <= end);
  var html = document.documentElement;
  if (!live) { html.classList.remove('cp-on'); return; }
  html.classList.add('cp-on');

  /* cuenta regresiva compartida: [data-cp-clock] con 4 [data-u] */
  function pad(n){ return (n < 10 ? '0' : '') + n; }
  function tick(){
    var t = Date.now(), clocks = document.querySelectorAll('[data-cp-clock]');
    clocks.forEach(function(c){
      var s = Date.parse(c.getAttribute('data-start') || d.start), e = Date.parse(c.getAttribute('data-end') || d.end);
      var state = t < s ? 'soon' : (t > e ? 'over' : 'live'), goal = state === 'soon' ? s : e, left = Math.max(0, goal - t);
      c.setAttribute('data-state', state);
      var l = c.querySelector('[data-label]'); if (l) l.textContent = c.getAttribute('data-' + state) || l.textContent;
      var u = c.querySelectorAll('[data-u]'), v = [Math.floor(left / 864e5), Math.floor(left / 36e5) % 24, Math.floor(left / 6e4) % 60, Math.floor(left / 1e3) % 60];
      u.forEach(function(x, i){ x.textContent = pad(v[i]); });
    });
  }
  tick(); setInterval(tick, 1000);

  /* popup + pestaña lateral */
  var dlg = document.querySelector('[data-cp-dlg]'), fab = document.querySelector('[data-cp-open]');
  function openD(){ if (!dlg || dlg.open) return; try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); } }
  function closeD(){ if (dlg && dlg.open) dlg.close(); }
  var onCamp = /\/collections\//.test(location.pathname) && location.pathname.indexOf(d.url.replace(/^https?:\/\/[^/]+/, '')) === 0;
  if (fab && !onCamp) { fab.hidden = false; fab.addEventListener('click', openD); }
  if (dlg) {
    dlg.querySelector('[data-cp-close]').addEventListener('click', closeD);
    dlg.addEventListener('click', function(e){ if (e.target === dlg) closeD(); });
    var seen = false; try { seen = sessionStorage.getItem(d.key) === '1'; } catch (e) {}
    if (!seen && !onCamp) setTimeout(function(){ openD(); try { sessionStorage.setItem(d.key, '1'); } catch (e) {} }, (d.delay || 0) * 1000);
  }

  /* etiqueta en tarjetas */
  var hs = d.handles || [];
  function chips(){
    document.querySelectorAll('.pcard [data-vn-list]').forEach(function(b){
      if (hs.indexOf(b.getAttribute('data-vn-list')) < 0) return;
      var box = b.closest('.pcard__img'); if (!box || box.querySelector('.cp-chip-card')) return;
      var old = box.querySelector('.pchip'), c = document.createElement('span');
      c.className = 'pchip cp-chip-card'; c.textContent = d.name;
      if (old) old.replaceWith(c); else box.insertBefore(c, box.firstChild);
    });
  }
  chips(); new MutationObserver(chips).observe(document.body, { childList: true, subtree: true });

  /* banner en la ficha del producto */
  var m = location.pathname.match(/\/products\/([^/?#]+)/);
  if (m && hs.indexOf(decodeURIComponent(m[1])) > -1) {
    var at = document.querySelector('.vnp__grid') || document.querySelector('[data-vnpk]');
    if (at) {
      var b = document.createElement('div');
      b.className = 'cp-banner';
      b.innerHTML = (d.logo ? '<img class="cp-banner__logo" src="' + d.logo + '" alt="" width="72" height="48">' : '') +
        '<p class="cp-banner__txt"><span>' + d.name + ' · ' + d.dates + '</span><b>Este producto está en ' + d.name + '</b></p>' +
        '<div class="cp-clock" data-cp-clock data-live="Termina en" data-soon="Empieza en" data-over=""><span class="cp-clock__t" data-label>Termina en</span><span class="cp-clock__u"><span><b data-u>00</b><small>d</small></span><span><b data-u>00</b><small>h</small></span><span><b data-u>00</b><small>m</small></span><span><b data-u>00</b><small>s</small></span></span></div>';
      at.parentNode.insertBefore(b, at); tick();
    }
  }
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeD(); });
})();
